

import React, { useEffect, useRef } from 'react';

// This lets TypeScript know that window.adsbygoogle can exist.
declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

interface AdBannerProps {
  'data-ad-client': string;
  'data-ad-slot': string;
  'data-ad-format'?: string;
  'data-full-width-responsive'?: string;
  className?: string;
}

const AdBanner: React.FC<AdBannerProps> = (props) => {
  // Fix: The ref for an <ins> element should be of type HTMLModElement.
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    const pushAd = () => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense error:', e);
      }
    };

    // We check if the ad container is rendered and has a width.
    // If not, we wait a moment for the layout to be calculated.
    if (adRef.current && adRef.current.offsetWidth > 0) {
      pushAd();
    } else {
      const timeoutId = setTimeout(() => {
        pushAd();
      }, 200); // 200ms delay as a fallback
      
      // Cleanup the timeout if the component unmounts
      return () => clearTimeout(timeoutId);
    }
  }, []); // Run only once when the component mounts

  // Pass all the data-* props to the <ins> tag
  const adProps: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(props)) {
      adProps[key] = value;
  }

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle ${props.className || ''}`}
      style={{ display: 'block', width: '100%' }}
      {...adProps}
    ></ins>
  );
};

export default AdBanner;
